import { useEffect, useState } from "react";
import routeService from "../../../services/routeService/RouteService";  // Add this service for fetching routes
import { IRoute } from "../../../models/route";  // Make sure you have an IRoute interface defined
import DataTable, { IColumn } from "../../../components/table/data/DataTable";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Toolbar from "../../../components/toolbar/Toolbar";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { routes } from "../../../routes";
import propertyGroupService from "../../../services/propertyGroupService/PropertyGroupService";

const useRouteColumns = () => {
    const { t } = useTranslation();

    const columns: IColumn<IRoute>[] = [
        { field: "name", headerName: t("table.route.name") },
        {
            field: "propertyGroupName",
            headerName: t("table.property.name"),
            transform: {
                render: (data: IRoute) => (
                    <Typography>
                        {data.propertyGroupName}
                    </Typography>
                ),
                filterTransform: (data: IRoute) => {
                    return data.propertyGroupName;
                },
            },
        },
        {
            field: "locals",
            headerName: t("table.local.locals"),
            transform: {
                render: (data: IRoute) => {
                    const localNames = (data.locals || [])
                        .map((l) => l.name)
                        .filter(name => name)
                        .join(", ");
                    return <Typography>{localNames || ""}</Typography>;
                },
                filterTransform: (data: IRoute) => {
                    const localNames = (data.locals || [])
                        .map((l) => l.name)
                        .filter(name => name)
                        .join(", ");
                    return localNames || "";
                },
            },
        },

    ];

    return columns;
};
const RoutePage = () => {
    const [routesData, setRoutesData] = useState<IRoute[]>([]);
    const columns = useRouteColumns();
    const navigate = useNavigate();
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);

    useEffect(() => {
        routeService.GetRoutesByCompany().then(async (routes) => {
            const propertyGroups = await propertyGroupService.GetPropertyGroups();
            const updatedRoutes = routes.map((route) => {
                const propertyGroup = propertyGroups.find(
                    (group) => group.id === route.propertyGroupId
                );
                return {
                    ...route,
                    propertyGroupName: propertyGroup?.name || "",
                };
            });
            setRoutesData(updatedRoutes);
        })
    }, []);

    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Toolbar
                onFilterClick={() => setIsFilterActive((old) => !old)}
                onCreate={() => navigate(routes.tableRoute.routeAdd)}
                isFilterActive={isFilterActive}
            />
            <DataTable
                dense
                rows={routesData}
                columns={columns}
                onRowClick={(row) =>
                    navigate("edit", { state: { ...row } })
                }
                getRowNavTo={(row) => "edit"}
            />
        </Box>
    );
};

export default RoutePage;
